import { Navigate, Outlet } from "react-router";

import { buildLoginRedirectUrl, isSameOriginPath } from "../utils/cognitoAuth";

/**
 * Navigates the browser to the in-app `/login` route for the current Tenant
 * subdomain when the Session_Cookie is missing/expired, carrying the current
 * in-application path as the `originalDestination` so the person is returned to
 * it after a successful Cognito login.
 *
 * Now that `/login` is an in-app SPA route on the same origin (declared as a
 * public route alongside the protected routes), this uses React Router in-app
 * navigation (`<Navigate replace>`) instead of a cross-origin full-page
 * `window.location.replace`, mirroring the existing guard pattern in
 * `externalRoutes.js`.
 *
 * The current path (`window.location.pathname + search`) is validated with
 * `isSameOriginPath` before it is carried as `originalDestination`; a value
 * that does not resolve to a same-origin path within the Tenant's own Insights
 * subdomain is discarded, so the redirect back after login can never be used to
 * send the browser to an arbitrary external destination.
 *
 * The Canvas/LTI login path is unaffected and continues to rely on the LTI
 * launch flow's own `target_url` redirect.
 */
function LoginNavigate() {
  const currentPath = window.location.pathname + window.location.search;
  const originalDestination = isSameOriginPath(currentPath) ? currentPath : "";
  return <Navigate to={buildLoginRedirectUrl(originalDestination)} replace />;
}

export default function ProtectedRoutes({ auth }) {
  return auth ? <Outlet /> : <LoginNavigate />;
}
